<template>
  <div>
    <div>
      <a
        :href="getLink()"
        class="inline-flex flex-no-wrap"
        @click.prevent.stop="onClick"
      >
        <!-- eslint-disable vue/no-v-html -->
        <span
          v-if="hasFinLabel"
          v-html="getFinLabel()"
        />
        <!-- eslint-enable vue/no-v-html -->
        <span
          v-else
          class="italic"
        >
          ohne FIN
        </span>
      </a>
    </div>
    <div>
      <a
        :href="getLink()"
        class="inline-flex flex-no-wrap"
        @click.prevent.stop="onClick"
      >
        <!-- eslint-disable vue/no-v-html -->
        <span
          v-if="hasCommLabel"
          v-html="getCommLabel()"
        />
        <!-- eslint-enable vue/no-v-html -->
        <span
          v-else
          class="italic"
        >
          ohne Kommissionsnummer
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import { isEmpty } from '@/helpers/utils'

export default {
  name: 'MiaDatatableFinCommColumn',

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  computed: {
    hasFinLabel() {
      return !isEmpty(this.getFinLabel())
    },

    hasCommLabel() {
      return !isEmpty(this.getCommLabel())
    }
  },

  methods: {
    ensureMetadata() {
      if (this.column.meta === undefined || Object.keys(this.column.meta).length === 0) {
        console.error('[mia-datatable-link-column]: Please provide a "meta" property in your column definition with the following signature: { schema: string [, finLabelProp: string|function [, commLabelProp: string|function ]] }.\n\n\tThe "schema" property will be used as link target. You can provide placeholders in the format :placeholder that will be replaced with the corresponding field from the row, e.g. "/users/:id", where :id will be replaced with the value of an "id" property of the row object.\n\n\tThe "labelProp" property is optional and can be used to utilize a custom property of the row object as label for the link. It defaults to the configured "field" property of the column definition. You can also provide a function with the signature "function(row: object): string" that retrieves the row as argument to compute a label by yourself.')
      }
    },

    getFinLabel() {
      const { finLabelProp } = this.column.meta

      if (finLabelProp === undefined) {
        return this.row[this.column.field]
      }

      if (typeof finLabelProp === 'function') {
        return finLabelProp(this.row)
      }

      if (this.row[finLabelProp] === undefined) {
        console.error(`[mia-datatable-link-column]: The property "${finLabelProp}" defined as finLabelProp does not exist on the row object.`)
        return ''
      }

      return this.row[finLabelProp]
    },

    getCommLabel() {
      const { commLabelProp } = this.column.meta

      if (commLabelProp === undefined) {
        return this.row[this.column.field]
      }

      if (typeof commLabelProp === 'function') {
        return commLabelProp(this.row)
      }

      if (this.row[commLabelProp] === undefined) {
        console.error(`[mia-datatable-link-column]: The property "${commLabelProp}" defined as commLabelProp does not exist on the row object.`)
        return ''
      }

      return this.row[commLabelProp]
    },

    getLink() {
      let template

      if (typeof this.column.meta.schema === 'function') {
        template = this.column.meta.schema(this.row)
      } else {
        template = this.column.meta.schema
      }

      // Extract all placeholders
      const parts = template.match(/:\w+/g)

      if (parts === null) {
        return template
      }

      parts
        // Remove the colon
        .map(placeholder => placeholder.replace(':', ''))
        // Apply each placeholder as replacement to the template
        .forEach((placeholder) => {
          if (this.row[placeholder] === undefined) {
            console.error(`[mia-datatable-link-column]: The placeholder ":${placeholder}" does not exist as property on the row object.`)
            return
          }

          template = template.replace(new RegExp(`:${placeholder}`, 'g'), this.row[placeholder])
        })

      return template
    },

    onClick() {
      const beforeCallback = get(this.column, 'meta.before', () => {})

      beforeCallback(this.row, this.getLink())
      this.$nextTick(() => {
        if (this.isExternal) {
          window.open(this.getLink())
        } else {
          this.$router.push(this.getLink())
        }
      })
    }
  }
}
</script>
